import React, { useEffect, useState } from 'react'
import Search from '../dashbord/search/search'
import { observer } from 'mobx-react-lite'
import useStages from '../../hooks/stages.hook'
import { useStatistics } from '../../hooks/statistics.hook'
import Loader from '../loader/loader'
import { UserStats } from './UserStats'
import { TotalStatsTable } from './TotalStatsTable'
import { EmptyStatsRow } from './EmptyStatsRow'
import Switcher from '../ui/swticher/switcher'
import usersStore from '../../store/users'
import { useNavigate } from 'react-router-dom'
import { Tooltip } from 'react-tooltip'
import Modal from '../modal/modal'

export const StatPage = observer(() => {
  const [payload, setPayload] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [isError, setIsError] = useState('')
  const [statsData, setStatsData] = useState([])
  const [originalData, setOriginalData] = useState([])
  const [totalStatsData, setTotalStatsData] = useState([])
  const [showAll, setShowAll] = useState(false)
  const [excelWarningModal, setExcelWarningModal] = useState({
    isOpen: false,
    text: ''
  })
  const { stages } = useStages()
  const { getStat, preparePayload, getExcelFile, getExcelManagerFile } = useStatistics()
  const {isAdmin, isRoleDefine} = usersStore
  const navigate = useNavigate()

  const getStatistics = async (payload) => {
    try {
      setIsLoading(true)
      setPayload(payload)
      const response = await getStat(payload)
      setOriginalData(response.data.usersStats)
      setTotalStatsData(response.data.totalStats)
    } catch (e) {
      setIsError('При запросе статистики произошла ошибка')
    } finally {
      setIsLoading(false)
    }
  }

  const onGetExcelFile =  async (payload) => {
    try {
      if(!payload['stage.id']) {
        setExcelWarningModal({isOpen: true, text: 'Для формирования файла необходимо выбрать этапы, а также дату или диапазон дат'})
        return;
      }
      setIsLoading(true)
      const requestReadyPayload = preparePayload(payload)
      await downloadFile(await getExcelFile(requestReadyPayload),payload)

    } catch(e) {
      setIsError('При генерации файла произошла ошибка')
    } finally {
      setIsLoading(false)
    }
  }

  const onGetManagerExcelFile =  async (payload) => {
    try {
      setIsLoading(true)
      const requestReadyPayload = preparePayload(payload)
      await downloadFile(await getExcelManagerFile(requestReadyPayload), payload)
    } catch(e) {
      setIsError('При генерации файла произошла ошибка')
    } finally {
      setIsLoading(false)
    }
  }
  

  const downloadFile = async (response, payload) => {
        const fileName = `${payload.dateFrom.val} - ${payload.dateTo.val}`
      if(response.type === 'text/plain') {
        const text = await response.text()
        setExcelWarningModal({isOpen: true, text})
      } else {
        const url = window.URL.createObjectURL(response);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${fileName}.xlsx`);
        document.body.appendChild(link);
        link.click();
        link.remove();
      }
  }

  useEffect(() => {
    if(isRoleDefine && !isAdmin) {
      navigate('/')
    }
  }, [isRoleDefine])

  useEffect(() => {
    if(showAll) {
      setStatsData(originalData)
    } else {
      setStatsData(originalData.filter(el => !!el.stages.length))
    }
  }, [showAll, originalData])

  const onSetRequest = (filterData) => {
    const requestReadyPayload = preparePayload(filterData)
    getStatistics(requestReadyPayload)
  }

  const onToggleShowAll = () => {
    setShowAll(!showAll)
  }

  const usersStatsRender = statsData.map(userStat => {
    return <UserStats payload={payload} key={userStat.user.id} userStat={userStat} />
  })

  const isDataRendered = !!statsData.length || !!totalStatsData.length

  return (
    <div className={`min-h-[100vh] bg-Dominant/Dop py-[3.6rem] flex flex-col`}>
      <div className={`flex-1 flex flex-col gap-[3.6rem] max-w-[96%] w-[calc(100vw-15rem)] m-auto relative`}>
        <div className="p-[1.2rem] bg-white flex gap-[2.6rem]">
          <div className={`h-[4.6rem]`}></div>
          <Search
            isFilterOpen={true}
            onSetRequest={onSetRequest}
            onGetExcelFile={onGetExcelFile}
            onGetManagerExcelFile={onGetManagerExcelFile}
            statsPage={true}
            isAllMod={true}
            isDataRendered={isDataRendered}
            stages={stages}></Search>
          <div className={`inline-flex min-w-[12.5rem]`}>
            <Switcher
              className={`min-w-[12.5rem] flex justify-center`}
              label={'Скрывать пустые данные'}
              active={!showAll}
              onChange={onToggleShowAll}
            />
          </div>
        </div>
        <div className={``}>
          {isLoading ? (
            <Loader />
          ) : (
            <div>
              {isDataRendered
                ? <>
                  {usersStatsRender}
                  {statsData.length > 1 &&
                    <TotalStatsTable totalStatsData={totalStatsData} />}
                </>
                : <EmptyStatsRow text={'Для рассчета статистики необходимо выбрать этапы, ответсвенных и диапазон дат'} />
              }
            </div>
          )}
        </div>
      </div>
      <Modal closeModal={() => setExcelWarningModal({isOpen: false, text: ''})} isOpen={excelWarningModal.isOpen}>
        <div className='w-[62rem] min-h-[10rem]'>
          <div className='py-[5rem] px-[7rem]'>
            <div className='flex flex-col gap-[2rem]'>
              <span className='text-Regular(24_30) text-center'>Внимание!</span>
              <span className='text-Regular(18_24) text-center'>
                {excelWarningModal.text}
              </span>
              <div className='flex justify-center gap-[5rem]'>
                <div onClick={() => setExcelWarningModal({isOpen: false, text: ''})}
                  className='hover:bg-Accent/Light_Green hover:cursor-pointer duration-300 ease-in-out min-w-[19rem] py-[1.1rem] group px-[1.8rem]  font-medium rounded-[8px] bg-Accent/Green text-white text-Regular(16_20)'>
                  <span className='flex justify-center  items-center gap-[0.8rem]'>
                    <span>Понятно</span>
                    <i className='icon-fcheck-circle text-Regular(18_24)'></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
      <Tooltip
        className='cell_tooltip'
        opacity='1'
        clickable={false}
        style={{
          backgroundColor: '#000000',
          padding: '12px',
          boxShadow: 'none',
          pointerEvents: 'auto',
          zIndex: 10,
          fontSize: '16px',
          maxWidth: '400px'
        }}
        id={'settings_tooltip'}></Tooltip>
    </div>
  )
})
